import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
export function SolutionSection() {
  return <Section background="sage" className="text-center" data-id="element-110">
      <h2 className="text-2xl md:text-4xl font-serif font-bold text-[#2D2A26] mb-4 md:mb-6" data-id="element-111">
        La solución: un plan listo para seguir (y repetir)
      </h2>

      <p className="text-base md:text-xl text-[#6B6560] mb-6 md:mb-10 max-w-3xl mx-auto leading-relaxed" data-id="element-112">
        <span className="font-bold text-[#5B7C5B]" data-id="element-113">
          Barriga Desinflamada (14 Días)
        </span>{' '}
        es un PDF diseñado para bajar hinchazón con una rutina simple: te dice
        qué smoothie tomar, cuándo, cuánto y qué hacer si algo te cae mal. Sin
        "detox" agresivos. Sin complicarte la vida.
      </p>

      <Button onClick={() => document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    })} data-id="element-114">
        Sí, lo quiero
      </Button>
    </Section>;
}